<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-5 page-container">
        <div class="row">
          <div class="col-12">
            <span class="h4 font-weight-bold">
              Sessión
              <!-- {{ sessionData.name }} -->
            </span>
          </div>
        </div>
        <div class="row my-4">
          <div class="col-12">
            <span class="subtitle">
              Defina los parámetros de la sesión de trabajo
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 icons-container">
            <!-- <span class="text-primary">
              <unicon name="award" :fill="secCol"></unicon>
              1er nivel
            </span>
            <span class="text-primary mx-4">
              <unicon name="university" :fill="secCol"></unicon>
              Colegio prueba
            </span>
            <span class="text-primary">
              <unicon name="graduation-hat" :fill="secCol"></unicon>
              Curso 1
            </span> -->
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <span class="h4">Estudiantes</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input
              type="text"
              class="form-control"
              placeholder="Filtrar por nombre"
              v-model="nameFilter"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span class="subtitle">
              Arrastra a los estudiantes hacia su grupo de trabajo
            </span>
          </div>
        </div>

        <div class="row ">
          <div class="col-md-10 mt-2 p-3 radius-10 student-container">
            <draggable
              v-model="list"
              group="students"
              class="drag-container custom-scroll"
            >
              <div class="row" v-for="element in list" :key="element.name">
                <div class="col-12">
                  <template
                    v-if="
                      !nameFilter ||
                        `${element.firstname} ${element.lastname}`
                          .toLowerCase()
                          .indexOf(nameFilter.toLowerCase()) > -1
                    "
                  >
                    <button class="button default">
                      {{ element.firstname }} {{ element.lastname }}
                    </button>
                  </template>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <div class="col-md-7 pt-5">
        <div class="row">
          <div
            class="col-md-6 my-2"
            v-for="(group, i) in renderList"
            :key="group"
          >
            <WorkGroupCard
              @update="onUpdate"
              @delete="onDelete"
              :id="i"
              :group="groups[i]"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <button class="button gray" @click="newGroup">
          Nuevo Grupo
        </button>
      </div>
      <div class="col-md-6 text-end">
        <!-- <button class="button primary mr-2" @click="prevPage">
          Volver
        </button> -->
        <button class="button secondary" @click="createWorkGroups">
          Continuar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import draggable from "vuedraggable";
import WorkGroupCard from "@/components/workSession/WorkGroupCard";

export default {
  name: "WGModalSecondPage",
  components: {
    WorkGroupCard,
    draggable,
  },
  props: {
    sessionData: {
      default: null,
    },
    editionData: {
      default: null,
    },
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
      nameFilter: "",
      list: [
        {},
        // { name: "Estudiante 5654", id: 5654 },
        // { name: "Estudiante 5732", id: 5732 },
        // { name: "Estudiante 5733", id: 5733 },
        // { name: "Estudiante 5734", id: 5734 },
        // { firstname: "John", id: 1 },
        // { firstname: "Joao", id: 2 },
        // { firstname: "Jean", id: 3 },
        // { firstname: "Gerard", id: 4 },
        // { firstname: "Juan", id: 5 },
        // { firstname: "Edgard", id: 6 },
        // { firstname: "Johnson", id: 7 },
        // { firstname: "Alan", id: 8 },
        // { firstname: "Jorge", id: 9 },
        // { firstname: "Luis", id: 10 },
      ],
      renderCounter: 0,
      renderList: [],
      groups: [],
    };
  },
  computed: {
    ...mapState(["dataUrl"]),
  },
  methods: {
    newGroup() {
      this.groups.push([]);
      this.renderList.push(this.renderCounter);
      this.renderCounter++;
    },
    onUpdate({ id, items }) {
      this.groups[id] = items;
    },
    onDelete({ id, items }) {
      this.groups.splice(id, 1);
      this.renderList.splice(id, 1);
      this.list = this.list.concat(items);
    },
    prevPage() {
      this.$emit("prevPage");
    },
    async getCourseStudents() {
      let loader = this.$loading.show();

      try {
        let { data } = await this.axios.post(
          `${this.dataUrl}/bookUser/getAllStudentListByCourseId?courseId=${this.sessionData.course.id}`
        );

        this.list = data.content;
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });

        // this.getCourseStudents();
      } finally {
        loader.hide();
      }
    },
    async getAllStudentsNotAssigned(sessionId) {
      let loader = this.$loading.show();

      try {
        let { data } = await this.axios.post(
          `${this.dataUrl}/workSession/getAllStudentsNotAssigned?workSessionId=${sessionId}`
        );

        this.list = data.content;
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });

        // this.getCourseStudents();
      } finally {
        loader.hide();
      }
    },
    async deleteGroupInWorkSession(id) {
      try {
        await this.axios.post(
          `${this.dataUrl}/workSession/deleteWorkGroup?workGroupId=${id}`
        );
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      }
    },
    async createWorkGroups() {
      if (this.editionData) {
        let loader = this.$loading.show();
        if (this.editionData.groups.length) {
          for (let group of this.editionData.groups) {
            await this.deleteGroupInWorkSession(group.id);
          }
        }
        loader.hide();
      }

      if (this.groups.length) {
        let loader = this.$loading.show();

        for (let i = 0; i < this.groups.length; i++) {
          if (this.groups[i].length) {
            let students = this.groups[i].map(student => ({ id: student.id }));
            let id = this.editionData
              ? this.editionData.id
              : this.sessionData.id;

            let apiData = {
              id: "",
              workGroup: {
                id: "",
                name: "",
                workSession: {
                  id,
                },
              },
              studentList: students,
            };

            try {
              let { data } = await this.axios.post(
                `${this.dataUrl}/workSession/saveStudentListInWorkGroup`,
                apiData
              );

              if (data.status.code == 1) {
                this.$notify({
                  title: ["Grupo creado éxitosamente"],
                  type: "success",
                });
              }
            } catch {
              this.$notify({
                title: ["Ocurrió un error", "No se pudo crear el grupo"],
                type: "danger",
              });
            }
          }
        }

        this.closeModal(false);
        loader.hide();
      }

      this.closeModal(false);
    },
    closeModal(showMsg) {
      this.$emit("closeModal", {
        showSuccessMessage: showMsg,
      });
    },
  },
  async mounted() {
    if (this.editionData) {
      let loader = this.$loading.show();

      await this.getAllStudentsNotAssigned(this.editionData.id);

      for (let group of this.editionData.groups) {
        let students = [];
        for (let { student } of group.students) {
          let { id, firstname, lastname } = student;

          students.push({
            id,
            firstname,
            lastname,
          });
        }
        this.groups.push(students);
        this.renderList.push(this.renderCounter);
        this.renderCounter++;
      }

      loader.hide();
    } else {
      this.getCourseStudents();
    }
  },
};
</script>

<style lang="scss" scoped>
.icons-container {
  min-width: 100px;
}

.student-container {
  background: #efefef;
}

button.default {
  width: 100%;
}

.drag-container {
  max-height: 168px;
  overflow-y: auto;
  overflow-x: hidden;
}

.page-container {
  box-shadow: 10px 1px 15px -14px rgba(64, 64, 64, 0.2);
}
</style>
